import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg';
import { validateResetCode } from '../../Api';

function ResetValidate() {
  const location = useLocation();
  const navigate = useNavigate();
  const canAccess = sessionStorage.getItem('canAccessValidate') === 'true';
  useEffect(() => {
    if (!canAccess) {       
      navigate('/forgot-password');
    }
   
  }, [canAccess, navigate]);

  const message = location.state?.message;
  const email = location.state?.email;
  // Form data to handle reset code
  const [formData, setFormData] = useState({
    email: email,
    code: '',
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    try {
       await validateResetCode(formData);
      // After success, navigate to the password reset page
      sessionStorage.removeItem('canAccessValidate');
      sessionStorage.setItem('canAccessReset', 'true');
      navigate('/reset-password', { state: { email: email } });
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message || 'Error validating the code.');
      } else {
        setError('Error validating the code.');
      }
    }
  };

  return (
    <div className="login-page">
      <img src={Logo} alt="Jasa Indonesia Perdana Logo" className="logo" />
      {message && <p>{message}</p>}
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="text"
            name="code" // Name should match formData key
            placeholder="Enter the reset code"
            value={formData.code}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit">Validate Code</button>
      </form>

      {successMessage && <p className="success">{successMessage}</p>}
      {error && <p className="error">{error}</p>}

      <div className="links">
      <a href="/login"><span>Back to Login</span></a>
      </div>
    </div>
  );
}

export default ResetValidate;
